import { render, staticRenderFns } from "./HomeGlitchText.vue?vue&type=template&id=9834f39a&scoped=true&"
import script from "./HomeGlitchText.vue?vue&type=script&lang=js&"
export * from "./HomeGlitchText.vue?vue&type=script&lang=js&"
import style0 from "./HomeGlitchText.vue?vue&type=style&index=0&id=9834f39a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9834f39a",
  null
  
)

export default component.exports